import styled from "styled-components"
import { withStyles } from "@material-ui/core"
import Dialog from "@material-ui/core/Dialog"
import Text from "components/Text"

export const ModalTitle = styled(Text)`
  margin: 0;
  text-align: ${props => props.align || "center"};
  text-transform: uppercase;
  letter-spacing: 5px;
`

export const ModalSubTitle = styled(Text)`
  margin: 0;
  text-align: ${props => props.align || "center"};
`

export const ModalContent = styled.div`
  margin: 30px 0 0 0;
  text-align: ${props => props.align || "center"};
`

export const IconCont = styled.div`
  width: 40px;
  height: 40px;
  display: inline-block;
  margin-right: 12px;
`

// Note: there is no need to duplicate styles to change one thing (e.g., "StyledDialogOverflow").
// Styles can be overridden using the PaperProps property.
export const StyledDialog = withStyles({
  paper: {
    //marginTop: "-100px",
    borderRadius: 4,
    margin: 0,
    maxWidth: "912px",
    width: "100%",
    padding: "50px 116px",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:1000px)"]: {
      padding: "40px 27px",
      borderRadius: 0,
      maxWidth: "100%",
      maxHeight: "inherit",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      position: "absolute",
    },
  },
})(Dialog)
